// extracted by mini-css-extract-plugin
module.exports = {"body":"_QO8AJ-_"};